<template>
  <generic-modal
    :value="value"
    :is-disabled="isDisabled"
    :is-loading="isLoading"
    title="Create Site Group"
    persistent
    confirm-text="Create"
    hide-louis
    @modal-confirm="onCreateConfirm"
    @modal-cancel="onCreateCancel"
  >
    <v-form ref="form" class="mt-4">
      <text-input v-model="formData.name" :rules="rules.first_name" label="Name *" class="mb-4" />
      <text-input v-model="formData.notification_channel" label="Notification Channel" class="mb-4" />
    </v-form>
  </generic-modal>
</template>

<script>
import { siteGroups } from '@/services/offers'
import GenericModal from '@/components/modals/generic-modal'
import TextInput from '@/components/forms/text-input'

export default {
  components: { GenericModal, TextInput },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      rules: { name: [v => !!v || 'Name is required'] },
      formData: {
        name: null,
        notification_channel: null,
      },
    }
  },
  computed: {
    isDisabled() {
      if (this.isLoading) return true
      return !this.formData.name
    },
  },
  methods: {
    async onCreateConfirm() {
      if (!this.$refs.form.validate()) return
      try {
        this.isLoading = true
        await siteGroups.create(this.formData)
        this.$notify({ type: 'success', text: 'Successfully created a site group' })
        this.isLoading = false
        this.onCreateCancel()
      } catch (err) {
        this.isLoading = false
        this.$notify({ type: 'error', text: 'Unable to create site group' })
      }
    },
    onCreateCancel() {
      this.$emit('cancel')
    },
  },
}
</script>
